<div class="store_details_kpi"
    [class.secondary]="this.colorKpi === 'secondary'"
    [class.blue]="this.colorKpi === 'blue'"
    [class.red]="this.colorKpi === 'red'"
    [class.green]="this.colorKpi === 'green'"
    [class.orange]="this.colorKpi === 'orange'"
    [class.purple]="this.colorKpi === 'purple'"
    [class.marvesting]="this.colorKpi === 'marvesting'"
    >
    <div class="store_details_kpi_label">{{this.labelKpi}}</div>
    <div class="store_details_kpi_value">{{this.valueKpi}}</div>
</div>